import styled, { css } from "styled-components";
import { COLORS, FONT_WEIGHT } from "../../../styles/constant";
import { device } from "../../../device";
import {
  reveal,
  fillBackgroundColor,
  flyInFromRight,
  moveUpDown,
} from "../../../styles/animation";

export const AboutContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${COLORS.yellow};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  > .content-container {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: 1em;
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
    transition: opacity 0.3s;

    ${(props: { isVisible: boolean }) => {
      if (!props.isVisible) {
        return css`
          opacity: 0;
        `;
      }
    }}

    @media ${device.tablet} {
      grid-template-columns: 1fr 1fr;
      max-width: 600px;
    }

    @media ${device.desktop} {
      max-width: 900px;
    }

    > .text-container {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      > .blob {
        position: absolute;
        z-index: 0;
        width: 120%;
        top: -15%;
        left: -10%;
        pointer-events: none;

        @media ${device.tablet} {
          width: 130%;
        }

        @media ${device.desktop} {
          width: 150%;
        }
      }

      > .title-container {
        position: relative;
        z-index: 1;
        line-height: 1.4;

        ${(props) => {
          if (props.isVisible)
            return css`
              opacity: 0;
              animation: ${reveal} 1s forwards 0.25s;
            `;
        }}

        >.text-small {
          font-size: 1.6em;
          font-weight: ${FONT_WEIGHT.semiBold};

          @media ${device.tablet} {
            font-size: 2.2em;
          }
        }

        > .name {
          font-size: 2.06em;
          font-weight: ${FONT_WEIGHT.bold};

          @media ${device.tablet} {
            font-size: 2.4em;
          }
        }

        > .job {
          font-size: 2.5em;
          font-weight: ${FONT_WEIGHT.extraBold};
          line-height: 1.1;

          @media ${device.tablet} {
            font-size: 3.3em;
          }
        }
      }

      > .desc {
        position: relative;
        z-index: 1;
        font-size: 1.06em;
        line-height: 1.6;
        font-weight: ${FONT_WEIGHT.regular};
        word-break: keep-all;
        letter-spacing: 0.8px;
        margin: 0.5em 0;

        ${(props) => {
          if (props.isVisible)
            return css`
              opacity: 0;
              animation: ${reveal} 1s forwards 0.5s;
            `;
        }}

        @media ${device.tablet} {
          font-size: 1.5em;
        }

        .highlight {
          background: linear-gradient(180deg, transparent 57%, #29fea6 47%);
          padding: 0 0.2em;
          background-size: 150% 150%;
          animation: ${fillBackgroundColor} 2s cubic-bezier(0.4, 0, 1, 1);
          animation-fill-mode: forwards;
        }

        > b {
          font-weight: 700;
          letter-spacing: 0.2em;
        }
      }

      > .button {
        position: relative;
        z-index: 1;

        ${(props) => {
          if (props.isVisible)
            return css`
              opacity: 0;
              animation: ${reveal} 1s forwards 0.75s;
              display: inline-block;
            `;
        }}

        @media ${device.tablet} {
          margin-top: 1em;
          font-size: 1.2em;
        }
      }
    }

    > .powerlifting {
      width: 100%;

      ${(props) => {
        if (props.isVisible)
          return css`
            opacity: 0;
            animation: ${flyInFromRight} 1s forwards 1s;
          `;
      }}
    }

    > .downward-arrow {
      width: 3em;
      height: 3em;
      position: absolute;
      bottom: 10%;
      left: 50%;
      animation: ${moveUpDown} 0.9s infinite;
    }
  }
`;
